var OCS = OCS || {};
if (!OCS.Bootstrap) {
    // In place for shapefile support, till a better version can be constructed
    OCS.Bootstrap = {
        isIE: function () {
            return ((navigator.appName === 'Microsoft Internet Explorer') || ((navigator.appName === 'Netscape') && (new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})").exec(navigator.userAgent) !== null)));
        }
    };
}
OCS.Bootstrap.init_interactive_viewer = function () {

};

OCS.Bootstrap.process_content_interactive_viewer = function (content) {
    content.getElements('.warning_popup').each(function (element) {
        new OCS.Classes.WarningPopup(element);
    });
};